import { render } from "./ApplicationLogo.vue?vue&type=template&id=883f3f0a"
const script = {}

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__